<template>
	<div class="lottery-page">
		<div class="lottery-background">
			<div class="bg-gradient"></div>
			<div class="bg-pattern"></div>
			<div class="glow glow-1"></div>
			<div class="glow glow-2"></div>
			<div class="glow glow-3"></div>
			<div class="star star-1">✦</div>
			<div class="star star-2">✦</div>
			<div class="star star-3">✦</div>
			<div class="particle particle-1"></div>
			<div class="particle particle-2"></div>
			<div class="particle particle-3"></div>
			<div class="particle particle-4"></div>
			<div class="particle particle-5"></div>
		</div>

		<div class="lottery-content-wrapper">
			<div class="page-header">
				<h1 class="main-title">
					<span class="title-icon">🎁</span>
					<span class="title-text">幸运大抽奖</span>
				</h1>
				<p class="sub-title">LUCKY DRAW</p>
			</div>

			<div class="three-column-layout">
				<div class="left-panel">
					<div class="panel-header">
						<span class="panel-icon">📋</span>
						<h2 class="panel-title">抽奖须知</h2>
					</div>
					<div class="notice-list">
						<div class="notice-item">
							<div class="notice-number">01</div>
							<div class="notice-content">
								<span class="notice-text">每日 08:00 开奖，每场赠送免费住酒店名额</span>
							</div>
						</div>
						<div class="notice-item">
							<div class="notice-number">02</div>
							<div class="notice-content">
								<span class="notice-text">每人每日限抽 1 次，参与抽奖需登录账号</span>
							</div>
						</div>
						<div class="notice-item">
							<div class="notice-number">03</div>
							<div class="notice-content">
								<span class="notice-text">中奖结果需在 24 小时内兑换，逾期失效</span>
							</div>
						</div>
						<div class="notice-item">
							<div class="notice-number">04</div>
							<div class="notice-content">
								<span class="notice-text">本活动最终解释权归主办方所有</span>
							</div>
						</div>
					</div>
				</div>

				<div class="center-panel">
					<div class="lottery-machine">
						<div class="machine-header">
							<div class="machine-title">
								<span class="machine-icon">🎰</span>
								<span>幸运摇号机</span>
							</div>
						</div>
						
						<div class="number-container">
							<div class="number-box" v-for="(num, index) in lotteryNumbers" :key="index">
								<div class="number-inner">
									<span class="number-digit">{{ num }}</span>
								</div>
							</div>
						</div>
						
						<div class="machine-footer">
							<div class="countdown">
								<span class="countdown-icon">⏱</span>
								<span class="countdown-text">距离开奖：{{ countdownText }}</span>
							</div>
						</div>
					</div>
					
					<div class="button-area">
						<button class="lottery-btn" @click="drawLottery" :disabled="!canDraw || isDrawing">
							<span class="btn-icon">✨</span>
							<span class="btn-text">{{ buttonText }}</span>
						</button>
						<p class="remaining-chances">
							<span class="chances-icon">🎫</span>
							{{ chanceText }}
						</p>
					</div>
				</div>

				<div class="right-panel">
					<div class="formula-section">
						<div class="section-header">
							<span class="section-icon">📝</span>
							<h3 class="section-title">中奖公示</h3>
						</div>
						<div class="formula-content">
							<div class="formula-main" v-if="todayWinnerCode">
								<span class="formula-label">今日中奖码：</span>
								<span class="formula-value winner-code">{{ todayWinnerCode }}</span>
							</div>
							<div class="formula-main" v-else>
								<span class="formula-label">今日中奖码：</span>
								<span class="formula-value">待开奖</span>
							</div>
							<p class="formula-desc" v-if="todayWinnerName">中奖用户：{{ todayWinnerName }}</p>
							<p class="formula-desc" v-else>每日08:00自动开奖</p>
						</div>
					</div>
					
					<div class="participants-section">
						<div class="section-header">
							<span class="section-icon">👥</span>
							<h3 class="section-title">近期参与</h3>
						</div>
						<div class="participants-list-wrapper">
							<div class="participants-list" :class="{ 'scrolling': isScrolling }">
								<div class="participant-item" v-for="(item, index) in participants" :key="index">
									<div class="participant-rank">{{ index + 1 }}</div>
									<div class="participant-info">
										<span class="participant-name">{{ item.name }}</span>
										<span class="participant-time">{{ item.time }}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			
			<div class="bottom-info">
				<div class="info-item">
					<span class="info-icon">📌</span>
					<span class="info-text">参与方式：每日进入页面点击立即抽奖即可参与</span>
				</div>
				<div class="info-item">
					<span class="info-icon">🎁</span>
					<span class="info-text">兑奖方式：中奖后在个人中心 - 我的奖品中兑换</span>
				</div>
				<div class="info-item" v-if="!isAdmin">
					<span class="info-icon">💬</span>
					<span class="info-text">客服咨询：在线客服 00:00-23:59</span>
				</div>
				<div class="info-item" v-else>
					<span class="info-icon">⚙️</span>
					<span class="info-text">后台管理：点击抽奖按钮设置中奖码</span>
				</div>
			</div>
		</div>

		<el-dialog title="设置今日中奖码" :visible.sync="adminDialogVisible" width="500px" center>
			<div class="admin-dialog-content">
				<p class="admin-tip">选择中奖用户或手动输入中奖码</p>
				<div class="admin-section">
					<label>选择中奖用户：</label>
					<select v-model="selectedUserId" @change="onUserSelect">
						<option :value="0">-- 选择今日参与用户 --</option>
						<option v-for="user in todayParticipants" :key="user.id" :value="user.id">
							{{ user.name }} - {{ user.code }}
						</option>
					</select>
				</div>
				<div class="admin-divider">或</div>
				<div class="admin-section">
					<label>手动输入中奖码：</label>
					<input type="text" v-model="manualCode" placeholder="请输入8位中奖码" maxlength="8" />
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="adminDialogVisible = false">取消</el-button>
				<el-button type="primary" @click="submitWinnerCode">确认设置</el-button>
			</span>
		</el-dialog>

		<el-dialog title="我的抽奖记录" :visible.sync="historyDialogVisible" width="600px" center>
			<div class="history-dialog-content">
				<div class="history-list">
					<div class="history-item" v-for="(item, index) in myHistory" :key="index">
						<div class="history-code">
							<span class="code-label">抽奖码：</span>
							<span class="code-value">{{ item.code }}</span>
						</div>
						<div class="history-date">{{ item.date }}</div>
						<div class="history-status" :class="{ 'winner': item.is_winner }">
							{{ item.is_winner ? '🎉 已中奖' : '未中奖' }}
						</div>
					</div>
					<div class="history-empty" v-if="myHistory.length === 0">
						暂无抽奖记录
					</div>
				</div>
			</div>
		</el-dialog>

		<el-dialog title="历史中奖记录" :visible.sync="winnersDialogVisible" width="600px" center>
			<div class="history-dialog-content">
				<div class="history-list">
					<div class="history-item" v-for="(item, index) in historyWinners" :key="index">
						<div class="history-code">
							<span class="code-label">中奖用户：</span>
							<span class="code-value">{{ item.name }}</span>
						</div>
						<div class="history-code">
							<span class="code-label">中奖码：</span>
							<span class="code-value">{{ item.code }}</span>
						</div>
						<div class="history-date">{{ item.date }}</div>
					</div>
					<div class="history-empty" v-if="historyWinners.length === 0">
						暂无中奖记录
					</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import requests from '@/utils/axios'

export default {
	name: 'Lottery',
	data() {
		return {
			lotteryNumbers: ['00', '00', '00', '00'],
			countdownText: '00 时 00 分 00 秒',
			remainingChances: 0,
			canDraw: false,
			isDrawing: false,
			isAdmin: false,
			userId: 0,
			todayCode: null,
			todayWinnerCode: null,
			todayWinnerName: null,
			participants: [],
			isScrolling: false,
			countdownInterval: null,
			refreshInterval: null,
			adminDialogVisible: false,
			historyDialogVisible: false,
			winnersDialogVisible: false,
			selectedUserId: 0,
			manualCode: '',
			todayParticipants: [],
			myHistory: [],
			historyWinners: []
		}
	},
	computed: {
		userinfo() {
			return this.$store.getters.userinfo
		},
		groupId() {
			return this.$store.getters.group_id
		},
		isLoggedIn() {
			return this.$store.getters.login || (this.userinfo && this.userinfo.id)
		},
		buttonText() {
			if (!this.isLoggedIn) {
				return '登录参与'
			}
			if (this.isAdmin) {
				return '设置中奖码'
			}
			if (this.todayCode) {
				return '已参与抽奖'
			}
			if (this.isDrawing) {
				return '抽奖中...'
			}
			return '立即抽奖'
		},
		chanceText() {
			if (!this.isLoggedIn) {
				return '登录后可参与抽奖'
			}
			if (this.todayCode) {
				return `您的抽奖码：${this.todayCode}`
			}
			return `剩余 ${this.remainingChances} 次抽奖机会`
		}
	},
	async mounted() {
		await this.getLotteryInfo()
		this.getParticipants()
		this.getTodayWinner()
		this.getHistoryWinners()
		this.startCountdown()
		this.refreshData()
	},
	beforeDestroy() {
		if (this.countdownInterval) {
			clearInterval(this.countdownInterval)
		}
		if (this.refreshInterval) {
			clearInterval(this.refreshInterval)
		}
	},
	methods: {
		async getLotteryInfo() {
			try {
				const token = localStorage.getItem('usertoken')
				const adminId = localStorage.getItem('admin_id')
				
				const res = await requests({
					url: '/lottery/getinfo',
					method: 'post',
					data: { token }
				})
				
				if (res.data.code === 1) {
					const data = res.data.data
					this.countdownText = data.countdown_text
					this.canDraw = data.can_draw
					this.remainingChances = data.remaining_chances
					this.todayCode = data.today_code
					this.todayWinnerCode = data.today_winner_code
					this.isAdmin = data.is_admin
					this.userId = data.user_id
				}
			} catch (e) {
				console.error('获取抽奖信息失败', e)
			}
		},
		async getParticipants() {
			try {
				const res = await requests({
					url: '/lottery/getparticipants',
					method: 'post',
					data: {}
				})
				
				if (res.data.code === 1) {
					this.participants = res.data.data
					this.isScrolling = true
				}
			} catch (e) {
				console.error('获取参与者列表失败', e)
			}
		},
		async getTodayWinner() {
			try {
				const res = await requests({
					url: '/lottery/gettodaywinner',
					method: 'post',
					data: {}
				})
				
				if (res.data.code === 1 && res.data.data) {
					this.todayWinnerCode = res.data.data.code
					this.todayWinnerName = res.data.data.name
				}
			} catch (e) {
				console.error('获取今日中奖者失败', e)
			}
		},
		async getHistoryWinners() {
			try {
				const res = await requests({
					url: '/lottery/gethistorywinners',
					method: 'post',
					data: {}
				})
				
				if (res.data.code === 1) {
					this.historyWinners = res.data.data
				}
			} catch (e) {
				console.error('获取历史中奖记录失败', e)
			}
		},
		async drawLottery() {
			if (!this.isLoggedIn) {
				this.$message.warning('请先登录')
				this.$store.commit('SET_open_login', true)
				return
			}

			if (this.isAdmin) {
				this.openAdminDialog()
				return
			}

			if (!this.canDraw || this.isDrawing || this.todayCode) {
				if (this.todayCode && !this.isAdmin) {
					this.openHistoryDialog()
				}
				return
			}
			
			this.isDrawing = true
			
			try {
				const token = localStorage.getItem('usertoken')
				const res = await requests({
					url: '/lottery/draw',
					method: 'post',
					data: { token }
				})
				
				if (res.data.code === 1) {
					const result = res.data.data
					this.todayCode = result.lottery_code
					
					let count = 0
					const maxCount = 20
					const interval = setInterval(() => {
						this.lotteryNumbers = this.lotteryNumbers.map(() => {
							return String(Math.floor(Math.random() * 100)).padStart(2, '0')
						})
						
						count++
						if (count >= maxCount) {
							clearInterval(interval)
							this.lotteryNumbers = result.numbers
							this.isDrawing = false
							this.canDraw = false
							
							this.$message.success('抽奖完成！您的抽奖码：' + result.lottery_code)
							this.getLotteryInfo()
							this.getParticipants()
						}
					}, 100)
				} else {
					this.isDrawing = false
					this.$message.error(res.data.msg || '抽奖失败')
				}
			} catch (e) {
				this.isDrawing = false
				this.$message.error('抽奖失败，请稍后重试')
			}
		},
		async openAdminDialog() {
			try {
				const token = localStorage.getItem('usertoken')
				const res = await requests({
					url: '/lottery/getwinnerlist',
					method: 'post',
					data: { token }
				})
				
				if (res.data.code === 1) {
					const todayCodes = res.data.data.today_codes
					this.todayParticipants = todayCodes.map(code => ({
						id: 0,
						name: '用户 ' + code.substring(0, 4) + '***',
						code: code
					}))
				}
			} catch (e) {
				console.error('获取今日抽奖码列表失败', e)
			}
			
			this.selectedUserId = 0
			this.manualCode = ''
			this.adminDialogVisible = true
		},
		onUserSelect() {
			if (this.selectedUserId > 0) {
				this.manualCode = ''
			}
		},
		async submitWinnerCode() {
			if (!this.selectedUserId && !this.manualCode) {
				this.$message.warning('请选择中奖用户或输入中奖码')
				return
			}

			try {
				const token = localStorage.getItem('usertoken')
				const res = await requests({
					url: '/lottery/setwinnercode',
					method: 'post',
					data: {
						token,
						user_id: this.selectedUserId,
						code: this.manualCode
					}
				})
				
				if (res.data.code === 1) {
					this.$message.success('设置成功')
					this.adminDialogVisible = false
					this.getTodayWinner()
					this.getLotteryInfo()
				} else {
					this.$message.error(res.data.msg || '设置失败')
				}
			} catch (e) {
				this.$message.error('设置失败，请稍后重试')
			}
		},
		async openHistoryDialog() {
			try {
				const token = localStorage.getItem('usertoken')
				const res = await requests({
					url: '/lottery/getmyhistory',
					method: 'post',
					data: { token }
				})
				
				if (res.data.code === 1) {
					this.myHistory = res.data.data
				}
			} catch (e) {
				console.error('获取历史记录失败', e)
			}
			
			this.historyDialogVisible = true
		},
		openWinnersDialog() {
			this.getHistoryWinners()
			this.winnersDialogVisible = true
		},
		startCountdown() {
			this.updateCountdown()
			this.countdownInterval = setInterval(() => {
				this.updateCountdown()
			}, 1000)
		},
		updateCountdown() {
			const now = new Date()
			const today = now.getFullYear() + '-' + 
				String(now.getMonth() + 1).padStart(2, '0') + '-' + 
				String(now.getDate()).padStart(2, '0')
			
			let drawTime = new Date(today + ' 08:00:00')
			
			if (now >= drawTime) {
				drawTime = new Date(today + ' 08:00:00')
				drawTime.setDate(drawTime.getDate() + 1)
			}
			
			const diff = Math.floor((drawTime - now) / 1000)
			
			const hours = Math.floor(diff / 3600)
			const minutes = Math.floor((diff % 3600) / 60)
			const seconds = diff % 60
			
			this.countdownText = String(hours).padStart(2, '0') + ' 时 ' + 
				String(minutes).padStart(2, '0') + ' 分 ' + 
				String(seconds).padStart(2, '0') + ' 秒'
		},
		refreshData() {
			this.refreshInterval = setInterval(() => {
				this.getParticipants()
				this.getTodayWinner()
				this.getLotteryInfo()
			}, 30000)
		}
	}
}
</script>

<style scoped>
.lottery-page {
	position: relative;
	width: 100%;
	min-height: calc(100vh - 200px);
	padding: 30px 0 40px;
	background: linear-gradient(180deg, #F8FAFC 0%, #E8F4F8 50%, #E0F2FE 100%);
}

.lottery-page * {
	margin: 0;
	padding: 0;
	box-sizing: border-box;
}

.lottery-background {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	overflow: hidden;
	z-index: 0;
	pointer-events: none;
}

.bg-gradient {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: radial-gradient(circle at 30% 20%, rgba(59, 130, 246, 0.08) 0%, transparent 50%);
}

.bg-pattern {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-image: 
		linear-gradient(rgba(59, 130, 246, 0.03) 1px, transparent 1px),
		linear-gradient(90deg, rgba(59, 130, 246, 0.03) 1px, transparent 1px);
	background-size: 50px 50px;
}

.glow {
	position: absolute;
	border-radius: 50%;
	filter: blur(40px);
}

.glow-1 {
	width: 400px;
	height: 400px;
	background: radial-gradient(circle, rgba(59, 130, 246, 0.1) 0%, transparent 70%);
	top: 10%;
	left: 5%;
}

.glow-2 {
	width: 350px;
	height: 350px;
	background: radial-gradient(circle, rgba(147, 197, 253, 0.08) 0%, transparent 70%);
	top: 60%;
	right: 5%;
}

.glow-3 {
	width: 300px;
	height: 300px;
	background: radial-gradient(circle, rgba(96, 165, 250, 0.08) 0%, transparent 70%);
	bottom: 15%;
	left: 20%;
}

.star {
	position: absolute;
	font-size: 18px;
	filter: drop-shadow(0 2px 4px rgba(59, 130, 246, 0.3));
}

.star-1 {
	top: 25%;
	right: 15%;
}

.star-2 {
	top: 35%;
	left: 10%;
}

.star-3 {
	bottom: 35%;
	right: 20%;
}

.particle {
	position: absolute;
	border-radius: 50%;
	background: linear-gradient(135deg, rgba(255, 255, 255, 0.8) 0%, rgba(59, 130, 246, 0.5) 100%);
	box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
}

.particle-1 {
	width: 6px;
	height: 6px;
	top: 30%;
	left: 35%;
}

.particle-2 {
	width: 5px;
	height: 5px;
	top: 40%;
	right: 25%;
}

.particle-3 {
	width: 7px;
	height: 7px;
	bottom: 30%;
	left: 15%;
}

.particle-4 {
	width: 4px;
	height: 4px;
	top: 50%;
	right: 35%;
}

.particle-5 {
	width: 5px;
	height: 5px;
	bottom: 25%;
	right: 30%;
}

.lottery-content-wrapper {
	position: relative;
	z-index: 1;
	max-width: 1300px;
	margin: 0 auto;
	padding: 0 24px;
}

.page-header {
	text-align: center;
	margin-bottom: 32px;
	padding: 20px 0;
}

.main-title {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 12px;
	margin-bottom: 8px;
}

.title-icon {
	font-size: 48px;
}

.title-text {
	font-size: 44px;
	font-weight: bold;
	background: linear-gradient(135deg, #1E40AF 0%, #3B82F6 50%, #60A5FA 100%);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	background-clip: text;
	letter-spacing: 6px;
	text-shadow: 0 2px 12px rgba(59, 130, 246, 0.2);
}

.sub-title {
	font-size: 14px;
	font-weight: bold;
	color: #64748B;
	letter-spacing: 8px;
	text-transform: uppercase;
}

.three-column-layout {
	display: flex;
	justify-content: center;
	align-items: stretch;
	gap: 24px;
	margin-bottom: 32px;
}

.left-panel {
	width: 320px;
	flex-shrink: 0;
	background: rgba(255, 255, 255, 0.95);
	border-radius: 20px;
	padding: 24px;
	box-shadow: 0 4px 24px rgba(59, 130, 246, 0.12);
	border: 1px solid rgba(255, 255, 255, 0.8);
}

.panel-header {
	display: flex;
	align-items: center;
	gap: 10px;
	margin-bottom: 20px;
	padding-bottom: 14px;
	border-bottom: 2px solid rgba(59, 130, 246, 0.15);
}

.panel-icon {
	font-size: 26px;
}

.panel-title {
	font-size: 20px;
	font-weight: bold;
	background: linear-gradient(135deg, #1E40AF 0%, #3B82F6 100%);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	background-clip: text;
}

.notice-list {
	display: flex;
	flex-direction: column;
	gap: 12px;
}

.notice-item {
	display: flex;
	gap: 12px;
	padding: 14px 16px;
	background: linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(241, 245, 249, 0.8) 100%);
	border-radius: 14px;
	border: 1px solid rgba(59, 130, 246, 0.15);
	transition: all 0.3s ease;
}

.notice-item:hover {
	transform: translateX(4px);
	box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
}

.notice-number {
	width: 36px;
	height: 36px;
	flex-shrink: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	background: linear-gradient(135deg, #3B82F6 0%, #60A5FA 100%);
	border-radius: 10px;
	font-size: 16px;
	font-weight: bold;
	color: #FFFFFF;
	box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
}

.notice-content {
	flex: 1;
	display: flex;
	align-items: center;
}

.notice-text {
	font-size: 13px;
	color: #475569;
	line-height: 1.6;
}

.center-panel {
	flex: 1;
	max-width: 620px;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 24px;
}

.lottery-machine {
	width: 100%;
	background: linear-gradient(180deg, #FFFFFF 0%, #F8FAFC 100%);
	border-radius: 24px;
	padding: 28px;
	box-shadow: 0 8px 32px rgba(59, 130, 246, 0.18);
	border: 2px solid rgba(59, 130, 246, 0.2);
	position: relative;
	overflow: hidden;
}

.lottery-machine::before {
	content: '';
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	height: 4px;
	background: linear-gradient(90deg, #3B82F6 0%, #60A5FA 50%, #3B82F6 100%);
}

.machine-header {
	margin-bottom: 20px;
}

.machine-title {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	font-size: 18px;
	font-weight: bold;
	color: #1E40AF;
}

.machine-icon {
	font-size: 24px;
}

.number-container {
	display: flex;
	justify-content: center;
	gap: 14px;
	height: 100px;
	align-items: center;
}

.number-box {
	width: 110px;
	height: 100px;
	flex-shrink: 0;
}

.number-inner {
	width: 100%;
	height: 100%;
	background: linear-gradient(180deg, #FFFFFF 0%, #EFF6FF 100%);
	border-radius: 18px;
	border: 2px solid rgba(59, 130, 246, 0.4);
	box-shadow: 
		0 4px 12px rgba(59, 130, 246, 0.15),
		inset 0 2px 8px rgba(255, 255, 255, 0.8);
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	overflow: hidden;
}

.number-inner::before {
	content: '';
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	height: 50%;
	background: linear-gradient(180deg, rgba(255, 255, 255, 0.6) 0%, transparent 100%);
	border-radius: 18px 18px 0 0;
}

.number-digit {
	font-size: 52px;
	font-weight: bold;
	background: linear-gradient(180deg, #1E40AF 0%, #3B82F6 100%);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	background-clip: text;
	font-family: 'Arial', sans-serif;
	position: relative;
	z-index: 1;
}

.machine-footer {
	margin-top: 20px;
	padding-top: 16px;
	border-top: 1px solid rgba(59, 130, 246, 0.15);
}

.countdown {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	padding: 12px 20px;
	background: linear-gradient(135deg, rgba(59, 130, 246, 0.08) 0%, rgba(147, 197, 253, 0.08) 100%);
	border-radius: 12px;
	border: 1px solid rgba(59, 130, 246, 0.2);
}

.countdown-icon {
	font-size: 22px;
}

.countdown-text {
	font-size: 16px;
	font-weight: bold;
	background: linear-gradient(135deg, #1E40AF 0%, #3B82F6 100%);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	background-clip: text;
	letter-spacing: 1px;
}

.button-area {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 12px;
	width: 100%;
}

.lottery-btn {
	width: 260px;
	height: 56px;
	background: linear-gradient(135deg, #3B82F6 0%, #60A5FA 30%, #93C5FD 50%, #60A5FA 70%, #3B82F6 100%);
	border-radius: 28px;
	border: 2px solid rgba(255, 255, 255, 0.6);
	box-shadow: 
		0 8px 24px rgba(59, 130, 246, 0.35),
		inset 0 2px 8px rgba(255, 255, 255, 0.3);
	cursor: pointer;
	transition: all 0.3s ease;
	position: relative;
	overflow: hidden;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;
}

.lottery-btn::before {
	content: '';
	position: absolute;
	top: 0;
	left: -100%;
	width: 100%;
	height: 100%;
	background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
	transition: left 0.5s ease;
}

.lottery-btn:hover::before {
	left: 100%;
}

.lottery-btn:hover:not(:disabled) {
	transform: translateY(-3px);
	box-shadow: 
		0 12px 32px rgba(59, 130, 246, 0.45),
		inset 0 2px 8px rgba(255, 255, 255, 0.3);
}

.lottery-btn:active:not(:disabled) {
	transform: translateY(-1px);
}

.lottery-btn:disabled {
	opacity: 0.6;
	cursor: not-allowed;
}

.btn-icon {
	font-size: 22px;
	filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.15));
}

.btn-text {
	font-size: 20px;
	font-weight: bold;
	color: #FFFFFF;
	letter-spacing: 4px;
	text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.remaining-chances {
	display: flex;
	align-items: center;
	gap: 6px;
	font-size: 13px;
	color: #64748B;
}

.chances-icon {
	font-size: 16px;
}

.right-panel {
	width: 320px;
	flex-shrink: 0;
	display: flex;
	flex-direction: column;
	gap: 20px;
}

.formula-section,
.participants-section {
	background: rgba(255, 255, 255, 0.95);
	border-radius: 20px;
	padding: 24px;
	box-shadow: 0 4px 24px rgba(59, 130, 246, 0.12);
	border: 1px solid rgba(255, 255, 255, 0.8);
}

.section-header {
	display: flex;
	align-items: center;
	gap: 10px;
	margin-bottom: 18px;
	padding-bottom: 14px;
	border-bottom: 2px solid rgba(59, 130, 246, 0.15);
}

.section-icon {
	font-size: 26px;
}

.section-title {
	font-size: 20px;
	font-weight: bold;
	background: linear-gradient(135deg, #1E40AF 0%, #3B82F6 100%);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	background-clip: text;
}

.formula-content {
	background: linear-gradient(135deg, rgba(241, 245, 249, 0.8) 0%, rgba(255, 255, 255, 0.9) 100%);
	border-radius: 14px;
	padding: 18px 20px;
	border: 1px solid rgba(59, 130, 246, 0.15);
}

.formula-main {
	display: flex;
	align-items: center;
	gap: 8px;
	margin-bottom: 10px;
}

.formula-label {
	font-size: 15px;
	font-weight: bold;
	color: #475569;
}

.formula-value {
	font-size: 16px;
	font-weight: bold;
	background: linear-gradient(135deg, #1E40AF 0%, #3B82F6 100%);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	background-clip: text;
}

.formula-value.winner-code {
	font-size: 24px;
	color: #F59E0B;
}

.formula-desc {
	font-size: 13px;
	color: #64748B;
	line-height: 1.5;
}

.participants-list-wrapper {
	max-height: 300px;
	overflow: hidden;
}

.participants-list {
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.participants-list.scrolling {
	animation: scroll 30s linear infinite;
}

@keyframes scroll {
	0% {
		transform: translateY(0);
	}
	100% {
		transform: translateY(-50%);
	}
}

.participant-item {
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 12px 14px;
	background: linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(241, 245, 249, 0.7) 100%);
	border-radius: 12px;
	border: 1px solid rgba(59, 130, 246, 0.12);
	transition: all 0.3s ease;
}

.participant-item:hover {
	transform: translateX(4px);
	box-shadow: 0 4px 12px rgba(59, 130, 246, 0.12);
}

.participant-rank {
	width: 28px;
	height: 28px;
	flex-shrink: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	background: linear-gradient(135deg, #E0E7FF 0%, #C7D2FE 100%);
	border-radius: 8px;
	font-size: 13px;
	font-weight: bold;
	color: #4338CA;
}

.participant-info {
	flex: 1;
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.participant-name {
	font-size: 14px;
	color: #475569;
	font-weight: 500;
}

.participant-time {
	font-size: 12px;
	color: #94A3B8;
}

.bottom-info {
	display: flex;
	justify-content: center;
	gap: 32px;
	padding: 20px 28px;
	background: rgba(255, 255, 255, 0.85);
	border-radius: 16px;
	border: 1px solid rgba(59, 130, 246, 0.15);
	box-shadow: 0 4px 16px rgba(59, 130, 246, 0.1);
}

.info-item {
	display: flex;
	align-items: center;
	gap: 8px;
}

.info-icon {
	font-size: 18px;
}

.info-text {
	font-size: 13px;
	color: #475569;
}

.admin-dialog-content {
	padding: 20px;
}

.admin-tip {
	text-align: center;
	color: #64748B;
	margin-bottom: 20px;
}

.admin-section {
	margin-bottom: 15px;
}

.admin-section label {
	display: block;
	margin-bottom: 8px;
	font-weight: 500;
	color: #475569;
}

.admin-section select,
.admin-section input {
	width: 100%;
	padding: 10px 15px;
	border: 1px solid #E2E8F0;
	border-radius: 8px;
	font-size: 14px;
}

.admin-divider {
	text-align: center;
	color: #94A3B8;
	margin: 20px 0;
	position: relative;
}

.admin-divider::before,
.admin-divider::after {
	content: '';
	position: absolute;
	top: 50%;
	width: 40%;
	height: 1px;
	background: #E2E8F0;
}

.admin-divider::before {
	left: 0;
}

.admin-divider::after {
	right: 0;
}

.history-dialog-content {
	padding: 20px;
	max-height: 400px;
	overflow-y: auto;
}

.history-list {
	display: flex;
	flex-direction: column;
	gap: 12px;
}

.history-item {
	display: flex;
	align-items: center;
	gap: 15px;
	padding: 15px;
	background: #F8FAFC;
	border-radius: 10px;
	flex-wrap: wrap;
}

.history-code {
	display: flex;
	align-items: center;
	gap: 8px;
}

.code-label {
	color: #64748B;
	font-size: 13px;
}

.code-value {
	font-weight: bold;
	color: #1E40AF;
	font-size: 16px;
}

.history-date {
	color: #94A3B8;
	font-size: 13px;
}

.history-status {
	padding: 4px 12px;
	border-radius: 20px;
	font-size: 12px;
	font-weight: 500;
	background: #E2E8F0;
	color: #64748B;
}

.history-status.winner {
	background: #FEF3C7;
	color: #F59E0B;
}

.history-empty {
	text-align: center;
	color: #94A3B8;
	padding: 40px;
}

@media (max-width: 1200px) {
	.three-column-layout {
		flex-wrap: wrap;
	}
	
	.left-panel,
	.right-panel {
		width: 100%;
	}
	
	.center-panel {
		max-width: 100%;
	}
}
</style>
